<template>
  <div v-loading="loading" style="height: inherit; overflow: hidden;">
    <div class="chart-pie" v-if="chartData && JSON.stringify(chartData) !== {}">
      <div class="radio-group">
        <el-radio-group v-model="radio" size="mini" @change="handleRadioChange">
          <!-- <el-radio-button label="goods">商品</el-radio-button> -->
          <el-radio-button label="product">产品</el-radio-button>
          <el-radio-button label="pack" v-if="isAllPlan && this.form['storeId'] == 0">包件</el-radio-button>
        </el-radio-group>
      </div>
      <el-row>
        <el-col :span="12">
          <div class="canvas1" ref="canvas1"></div>
        </el-col>
        <el-col :span="12">
          <div class="canvas2" ref="canvas2"></div>
        </el-col>
      </el-row>
    </div>
    
    <div class="chart-pie no-data" v-else>饼图-暂无数据</div>
  </div>
</template>

<script>
import mixin from '@/views/preSalePlan/utils/mixin.js'
export default {
  mixins: [mixin],
  props: ['form','timeType'],
  data() {
    return {
      radio: 'product',
      $instance: null,
      chartData: {},
      loading: false
    }
  },
  computed: {
    redioLabel() {
      if(this.radio === 'goods') return '商品';
      if(this.radio === 'product') return '产品';
      if(this.radio === 'pack') return '包件';
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    handleRadioChange(name) {
      this.init();
    },
    async init() {
      this.loading = true;
      let data = {
        planTime: this.form['planTime'],
        storeId: this.form['storeId'],
        type: this.radio,
        timeType: this.timeType == '日' ? 1 : 2
      };
      this.$q.preSalePlan.monthlyPieChart({data})
      .then(res=>{
        if(res.success && res.data) {
          this.chartData = res.data;
          this.$nextTick(_=>{
            this.render1();
            this.render2();
          })
        }else{
          this.chartData = null;
          this.$instance && this.$instance.clear();
        }
        this.loading = false;
      })
      .catch(_=>{
        this.chartsData = null;
        this.$instance && this.$instance.clear();
        this.loading = false;
      })
    },
    render1() {
      let $canvas = this.$refs['canvas1'];

      let $instance = this.$instance1;
      $instance && $instance.clear();
      $instance = this.$echarts.init($canvas);
      this.$instance = $instance;

      let option = {
          tooltip: {
              trigger: 'item'
          },
          series: [
              {
                  name: '',
                  type: 'pie',
                  radius: '50%',
                  data: this.chartData.innerPie.map(v=>{
                    return {
                      name: v.name,
                      value: v.num,
                      oversoldNum: v.oversoldNum
                    }
                  }),
                  emphasis: {
                      itemStyle: {
                          shadowBlur: 10,
                          shadowOffsetX: 0,
                          shadowColor: 'rgba(0, 0, 0, 0.5)'
                      }
                  },
                  itemStyle: {
                    color: param => {
                      switch(param.name) {
                        case '正常':
                          return '#3D84A8';
                        case '积压':
                          return '#ABEDD8';
                        case '超卖':
                          return '#46CDCF';
                      }
                    }
                  },
                  label: {
                    formatter: param => {
                      return `${this.redioLabel}${param.name}${param.value}种共${param.data.oversoldNum}套`
                      // \n${param.name}率${param.percent}%
                    }
                  }
              }
          ]
      };
      
      $instance.setOption(option);
    },
    render2() {
      let $canvas = this.$refs['canvas2'];

      let option = {
          tooltip: {
              trigger: 'item'
          },
          series: [
              {
                  name: '',
                  type: 'pie',
                  radius: '50%',
                  data: this.chartData.outPie.map(v=>{
                    return {
                      name: v.name,
                      value: v.num
                    }
                  }),
                  emphasis: {
                      itemStyle: {
                          shadowBlur: 10,
                          shadowOffsetX: 0,
                          shadowColor: 'rgba(0, 0, 0, 0.5)'
                      }
                  },
                  itemStyle: {
                    color: param => {
                      switch(param.name) {
                        case '正常=0':
                          return '#48466D';
                        case '积压>50%':
                          return '#4A8E8A';
                        case '20%<积压≤50%':
                          return '#4A8694';
                        case '0<积压≤20%':
                          return '#3D84A8';
                        case '0<超卖≤20%':
                          return '#46CDCF';
                        case '20%<超卖≤50%':
                          return '#82E0E1';
                        case '超卖>50%':
                          return '#ABEDD8';
                      }
                    }
                  },
                  label: {
                    formatter: param => {
                      return `${param.name}  ${param.value}(${param.percent}%)`
                    }
                  },
                  tooltip: {show: false}
              }
          ]
      };

      let $instance = this.$instance2;
      $instance && $instance.clear();
      $instance = this.$echarts.init($canvas);
      this.$instance = $instance;

      $instance.setOption(option);
    }
  }
}
</script>

<style lang="stylus" scoped>
  .canvas1
    width 100%
    height 300px
    background #ffffff
  .canvas2
    width 100%
    height 300px
    background #ffffff
  // @media screen and (min-width:900px)
    
  // @media screen and (min-width:1600px)
  //   .radio-group
  //     position absolute
  //     right 110px
  //     top -38px
  //     z-index 999
  .radio-group
    position static
    text-align right
    padding-right 15px
</style>